<template>
  <div>
    <h2 class="progress-header">Data Tracking Sheets</h2>
    <div class="progress-panel">
      <router-link
        @click.native="clickedPanel"
        target="_blank"
        aria-label="Progress Monitoring Link"
        :to="{name: 'StrategyDetailPage', params: {slugOrUuid: 'progress-monitoring'}}">
        <img
          src="https://assets.goalbookapp.com/images/Progress+Monitoring+Thumbnail+(2).png"
          class="progress-thumbnail"
          alt="">
      </router-link>
      <h3 class="panel-header">
        <router-link
          @click.native="clickedPanel"
          target="_blank"
          :to="{name: 'StrategyDetailPage', params: {slugOrUuid: 'progress-monitoring'}}">
          Progress Monitoring
        </router-link>
      </h3>
      <p>A teaching strategy page with a variety of printable data sheets to track progress on goals and objectives.</p>
    </div>
  </div>
</template>

<script>
import { toolkitUrls } from '@/links'
import { mapGetters } from 'vuex'

export default {
  name: 'ProgressMonitoringPanel',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('visibility', ['betaVisibility'])
  },
  props: {
    contentTitle: {
      type: String,
      required: true
    },
    contentUuid: {
      type: String,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  methods: {
    clickedPanel() {
      this.$sendEvent(
        'Clicked Progress Monitoring Link',
        {
          content_uuid: this.contentUuid,
          content_title: this.contentTitle,
          content_type: this.contentType
        },
        {
          cu: this.contentUuid,
          ct: this.contentTitle
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.progress-thumbnail {
  float: left;
  height: 70px;
  width: 85px;
  margin-right: 9px;
  margin-top: 5px;
}
.progress-panel {
  background-color: #fbfbdf;
  padding: 10px;
  border-radius: 2px;
  p {
    font-size: 13px;
  }
}
.panel-header {
  font-weight: 600;
  font-size: 16px;
  margin: 0;
}
.progress-header {
  margin-bottom: 10px;
}
</style>
